import { Reveal } from "./Reveal";
import { GOOGLE_FORM_URL } from "@/lib/links";
import { ArrowUpRight } from "lucide-react";

export const Pricing = () => (
  <section
    data-testid="pricing-section"
    className="bg-cream-2 px-6 md:px-12 py-28 md:py-40"
  >
    <div className="max-w-6xl mx-auto grid md:grid-cols-12 gap-12 md:gap-16 items-start">
      <div className="md:col-span-5">
        <Reveal>
          <p className="text-xs md:text-sm uppercase tracking-[0.3em] text-amethyst font-medium mb-6">
            The Investment
          </p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl tracking-tight leading-[1.05] text-soil">
            Three months of{" "}
            <span className="italic text-amethyst">devoted</span>, one-to-one
            support.
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="text-base md:text-lg text-clay leading-relaxed mt-8 max-w-md">
            Twelve weekly sessions of two hours, a personalised programme, an
            integration workbook, and ongoing support between sessions. A
            sacred container held just for you.
          </p>
        </Reveal>
      </div>

      <Reveal delay={0.15} className="md:col-span-6 md:col-start-7">
        <div className="border border-soil/15 rounded-2xl p-10 md:p-14 bg-cream">
          <p className="text-xs uppercase tracking-[0.25em] text-clay">
            The full 3-month journey
          </p>
          <p
            data-testid="pricing-amount"
            className="font-serif text-6xl md:text-7xl text-soil tracking-tight mt-4"
          >
            £2,000
          </p>
          <div className="mt-8 pt-8 border-t border-soil/15 space-y-4">
            <p className="text-sm md:text-base text-clay leading-relaxed">
              We can discuss a payment plan to suit your needs.
            </p>
            <p className="text-sm md:text-base text-clay leading-relaxed">
              We can explore what feels right for you and answer any questions
              on your free discovery call.
            </p>
          </div>
          <a
            data-testid="pricing-discovery-button"
            href={GOOGLE_FORM_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-10 inline-flex items-center gap-3 rounded-full bg-gold text-soil text-xs uppercase tracking-[0.18em] px-10 py-4 hover:bg-amethyst hover:text-cream transition-colors duration-300"
          >
            Begin with a discovery call
            <ArrowUpRight className="w-4 h-4" />
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
